/* Noventis 2.0 — utilidades de conversión
   - Añadir al carrito (uno o varios productos) y abrir el cajón
   - Barra fija de compra en la ficha
   - Popup de newsletter
   - Test de piel
*/
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function openDrawerWith(sections, firstId) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && sections) {
      /* Dawn oculta productos y cabecera mientras el cajón tiene .is-empty:
         hay que quitarla antes de pintar (como hace product-form.js) */
      drawer.classList.remove('is-empty');
      drawer.renderContents({ id: firstId, sections: sections });
      return true;
    }
    return false;
  }

  function nvAddToCart(items, button) {
    if (!items || !items.length) return Promise.resolve();
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('nv-loading');
    }
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) {
          window.alert(res.description);
          return;
        }
        if (!openDrawerWith(res.sections, items[0].id)) {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () { window.location.href = root + 'cart'; })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('nv-loading');
        }
      });
  }
  window.nvAddToCart = nvAddToCart;

  /* Botones genéricos: data-nv-add="123,456" (ids de variante separados por comas) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nv-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var ids = String(btn.getAttribute('data-nv-add')).split(',').filter(Boolean);
    var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
    nvAddToCart(items, btn);
  });

  /* Barra fija de compra (ficha de producto) */
  function initSticky() {
    var bar = document.querySelector('[data-nv-sticky]');
    if (!bar) return;
    var mainBtn = document.querySelector('product-info product-form [name="add"], .product-form__buttons [name="add"]');
    if (!mainBtn) { bar.remove(); return; }
    var trigger = bar.querySelector('[data-nv-sticky-btn]');
    trigger.addEventListener('click', function () {
      if (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true') {
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainBtn.click();
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        document.body.classList.toggle('nv-sticky-on', past);
      });
    });
    io.observe(mainBtn);
    /* Mantener precio y disponibilidad sincronizados con la variante */
    var syncState = function () {
      var priceEl = document.querySelector('product-info .price');
      var target = bar.querySelector('[data-nv-sticky-price]');
      if (priceEl && target) target.innerHTML = priceEl.outerHTML;
      trigger.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('span');
      var tl = trigger.querySelector('span');
      if (label && tl) tl.textContent = label.textContent.trim();
    };
    /* subscribe y PUB_SUB_EVENTS los declara Dawn (pubsub.js / constants.js) */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(syncState, 80); });
    }
  }

  /* Popup de newsletter */
  function initPopup() {
    var pop = document.querySelector('[data-nv-popup]');
    if (!pop) return;
    var key = 'nv_popup_seen';
    var shown = false;
    var seen = false;
    try { seen = window.localStorage.getItem(key) === '1'; } catch (err) {}
    var hasPosted = pop.hasAttribute('data-posted');

    function open() {
      if (shown) return;
      shown = true;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      var f = pop.querySelector('input[type="email"]');
      if (f) setTimeout(function () { f.focus(); }, 250);
    }
    function close() {
      pop.classList.remove('is-open');
      setTimeout(function () { pop.hidden = true; }, 250);
      shown = false;
      try { window.localStorage.setItem(key, '1'); } catch (err) {}
    }
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-nv-popup-close]') || e.target === pop) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && shown) close(); });

    if (hasPosted) { open(); try { window.localStorage.setItem(key, '1'); } catch (err) {} return; }
    if (seen || (window.Shopify && window.Shopify.designMode)) return;

    var delay = Number(pop.getAttribute('data-delay') || 10) * 1000;
    var timer = setTimeout(open, delay);
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY < 10 && window.innerWidth > 989 && !shown) {
        clearTimeout(timer);
        try { if (window.localStorage.getItem(key) === '1') return; } catch (err) {}
        open();
      }
    });
  }

  /* Test de piel */
  function initQuiz(scope) {
    (scope || document).querySelectorAll('[data-nv-quiz]').forEach(function (quiz) {
      if (quiz.dataset.ready) return;
      quiz.dataset.ready = '1';
      var steps = quiz.querySelectorAll('[data-step]');
      var results = quiz.querySelectorAll('[data-result]');
      var progress = quiz.querySelector('[data-progress]');
      var answers = {};
      function show(i) {
        steps.forEach(function (s, idx) { s.hidden = idx !== i; });
        if (progress) progress.style.width = ((i + 1) / (steps.length + 1)) * 100 + '%';
      }
      function finish() {
        steps.forEach(function (s) { s.hidden = true; });
        var match = null;
        results.forEach(function (r) {
          r.hidden = true;
          if (!match && r.getAttribute('data-result') === answers.concern) match = r;
        });
        if (!match && results.length) match = results[0];
        if (match) {
          match.hidden = false;
          var note = match.querySelector('[data-skin-note]');
          var src = quiz.querySelector('[data-note-for="' + answers.skin + '"]');
          if (note && src) note.textContent = src.textContent;
        }
        var end = quiz.querySelector('[data-quiz-end]');
        if (end) end.hidden = false;
        if (progress) progress.style.width = '100%';
        quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      quiz.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-answer]');
        if (opt) {
          var step = opt.closest('[data-step]');
          answers[step.getAttribute('data-step')] = opt.getAttribute('data-answer');
          step.querySelectorAll('[data-answer]').forEach(function (o) { o.setAttribute('aria-pressed', o === opt ? 'true' : 'false'); });
          var idx = Array.prototype.indexOf.call(steps, step);
          if (idx < steps.length - 1) show(idx + 1); else finish();
          return;
        }
        if (e.target.closest('[data-quiz-back]')) {
          var cur = Array.prototype.findIndex.call(steps, function (s) { return !s.hidden; });
          if (cur > 0) show(cur - 1);
          return;
        }
        if (e.target.closest('[data-quiz-restart]')) {
          answers = {};
          results.forEach(function (r) { r.hidden = true; });
          var end = quiz.querySelector('[data-quiz-end]');
          if (end) end.hidden = true;
          show(0);
        }
      });
      show(0);
    });
  }
  window.nvInitQuiz = initQuiz;

  function ready() {
    initSticky();
    initPopup();
    initQuiz();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', function (e) { initQuiz(e.target); });
})();
